import styled from 'styled-components';

export const SubSwitchGroupContent = styled.div`
    margin-top: 25px;
    margin-left: 45px;
`;
